import orders from '../../services/orders'

state = ->
  order_items: []

actions =
  set: ({ commit }, attributes) ->
    commit 'set', attributes

  clear: ({ commit }) ->
    commit 'destroy'

  fetch: ({ commit }, params) ->
    commit 'loading', true
    orders.fetch_order params, (response) =>
      if response.status == 'ok'
        commit 'set', response.order
        commit 'loading', false
        response.order

  approve_refund: ({ commit }, id) ->
    orders.approve_refund(id).then (response) ->
      commit 'set', response.order
      response

  completed: ({ commit }, id) ->
    orders.completed(id).then (response) ->
      commit 'set', response.order
      response

mutations =
  destroy: (state) ->
    state = (value = null for key, value of state)
    destroy_local()

  loading: (state, loading) ->
    state.loading = loading

  restore: (state) ->
    state = Object.assign state, { get_local()... }

  set: (state, order) ->
    state = Object.assign state, order
    set_local(state)


export default {
  namespaced: true
  state,
  actions,
  mutations
}

get_local = -> JSON.parse localStorage.getItem('order')

set_local = (data) -> localStorage.setItem 'order', JSON.stringify(data)

destroy_local = -> localStorage.removeItem 'order'
